export const MUTATION_SET_COUNT = /* GraphQL */ `
	mutation ($key: String!, $value: CountValueInput!) {
		setCount(key: $key, value: $value) {
			countValue {
				total
				cid
			}
		}
	}
`;
